import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getService(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createService(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/service" + pathname, body);
}

export async function updateService(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/service" + pathname, body);
}

export async function deleteService(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/service" + pathname, { data: body });
}
